import React, { useState } from "react";
import { Provider, SignIn } from "../firebase/auth";
import { reduxForm, Field } from "redux-form";
import { Link } from "react-router-dom";
import {
  Form,
  Button,
  Grid,
  Segment,
  Message,
  Divider
} from "semantic-ui-react";
import { Transition } from "react-transition-group";
import { TextInput } from "../templates/utils/form-fields";

let Login = ({ submitting, pristine, handleSubmit, invalid }) => {
  const [errorMessage, setErrorMessage] = useState();
  const [loading, setLoading] = useState(false);
  const [inProp, setInProp] = useState(false);

  const duration = 300;

  const defaultStyle = {
    transition: `opacity ${duration}ms ease-in-out`,
    opacity: 0
  };

  const transitionStyles = {
    entering: { opacity: 1 },
    entered: { opacity: 1 },
    exiting: { opacity: 0 },
    exited: { opacity: 0 }
  };

  const login = provider => {
    Provider(provider).then(
      result => {},
      error => {
        setErrorMessage(error.message);
      }
    );
  };

  const handleSubmitForm = values => {
    setLoading(true);
    SignIn(values.email, values.password).then(
      result => {},
      error => {
        setLoading(false);
        setErrorMessage("Email and / or password incorrect");
      }
    );
  };

  return (
    <Grid centered>
      <Grid.Column computer={4} tablet={8} mobile={16}>
        <Segment className="bm-auth">
          <div className="center">
            <Button
              onClick={() => login("saml.dunnhumby.onelogin.com")}
              type="button"
              className="onelogin"
              size="tiny"
            >
              Sign in with OneLogin
            </Button>
          </div>
          <Divider horizontal>or</Divider>
          <div className="center">
            <Button onClick={() => setInProp(true)} type="button" size="tiny">
              Sign in with email
            </Button>
          </div>
          <Transition in={inProp} timeout={500}>
            {state => (
              <div
                style={{
                  ...defaultStyle,
                  ...transitionStyles[state]
                }}
              >
                <Form onSubmit={handleSubmit(handleSubmitForm)}>
                  <Field
                    name="email"
                    label="Email"
                    type="email"
                    component={TextInput}
                    placeholder="joe@bloggs.com"
                  />
                  <Field
                    name="password"
                    label="Password"
                    type="password"
                    component={TextInput}
                    placeholder=""
                  />
                  <Button
                    disabled={submitting || pristine || invalid || loading}
                    positive
                    type="submit"
                    loading={submitting || loading}
                    size="tiny"
                  >
                    Login
                  </Button>
                  {errorMessage && <Message negative content={errorMessage} />}
                </Form>

                <Divider />
                <Link to="/forgotten-password">Forgotten password?</Link>
              </div>
            )}
          </Transition>
        </Segment>
      </Grid.Column>
    </Grid>
  );
};

const validate = values => {
  const testEmail = email => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const errors = {};

  if (!values.email) {
    errors.email = "Please enter your email address";
  }

  if (values.email) {
    if (!testEmail(values.email)) {
      errors.email = "Please enter a valid email address";
    }
  }

  if (!values.password) {
    errors.password = "Please enter your password";
  }

  return errors;
};

Login = reduxForm({
  validate,
  form: "loginForm"
})(Login);

export default Login;
